import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CrmCoreModule } from '@crm/core';
import { environment } from '@environment';
import { TrackingSource } from '@shared/core/types/tracking';
// TODO: use `@skyeng/libs/vimbox-core/tracking` lib
import { IVimCoreTrackingConfig, SkyengTrackingProvider, VimCoreTrackingModule } from '../vendor/tracking';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StorageModule } from '@ngx-pwa/local-storage';
import { PageCabinetModule } from './cabinet';
import { LocalizeModule, TranslocoRootModule } from './localize';
import { TranslocoMessageFormatModule } from '@ngneat/transloco-messageformat';
import { ISkyApiConfig, SkyApiModule } from '@skyeng/libs/shared/api';
import { registerAllLocalesData } from '@skyeng/libs/shared/i18n';

registerAllLocalesData();

export function vimCoreTrackingConfigFactory(): IVimCoreTrackingConfig {
  return {
    enabled: true,
    debug: !environment.tracking.skyengKey,
    source: environment.production ? TrackingSource.production : TrackingSource.testing,
    providers: [
      {
        useClass: SkyengTrackingProvider,
        key: environment.tracking.skyengKey,
      },
    ],
  };
}

export function skyApiConfigFactory(): ISkyApiConfig {
  return environment.api;
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    PageCabinetModule,
    CrmCoreModule,
    AppRoutingModule,
    SkyApiModule.forRoot(skyApiConfigFactory),
    StorageModule.forRoot({ IDBNoWrap: false }),
    VimCoreTrackingModule.forRoot(vimCoreTrackingConfigFactory),
    LocalizeModule.forRoot(),
    TranslocoMessageFormatModule.forRoot(),
    TranslocoRootModule.forRoot({ isProduction: environment.production }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'ru-RU' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
